import React from 'react';

const Loader = () => (
  <div className="flex items-center justify-center h-screen w-full bg-white dark:bg-gray-900">
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-2 border-primary-black dark:border-white border-t-transparent rounded-full animate-spin" />
      <span className="text-sm text-accent-gray">Loading...</span>
    </div>
  </div>
);

export default Loader;
